export class QueueConst {
  static displayColumns = () => {
    return [
      {
        title: 'Tên hàng đợi',
        key: 'display_name',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Kiểu',
        key: 'SERVICE_NAME',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Chi tiết quản lý',
        key: 'DESCRIPTION_MANAGER',
        display: true,
        allowSort: false,
        classes: '',
      },
    ];
  };
  static displayNameColumns = item => {
    return `<span class="">${item.QUEUE_ID} - ${item.DESCRIPTION}</span>`;
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/switchboard/queue/queue.const.ts